// socket.js
import { io } from 'socket.io-client';

const socket = io('https://usitebackend-36ad67a8d6c6.herokuapp.com/'); // Replace with your server URL
export default socket;
